/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils, bidiUtils, Bidi } from '@ba-ui-toolkit/utils';
import TruncatedText from '@ba-ui-toolkit/truncatedtext';
import styles from './Label.scss';

const labelClassName = styles.labelClassName.replace(/"/g, '');
const { sanitize } = propsUtils;
const { resolveBaseTextDir } = bidiUtils;

export default class Label extends Component {
	static propTypes = {
		label: PropTypes.string.isRequired,
		ellipsis: PropTypes.bool,
		htmlFor: PropTypes.string,
		disabled: PropTypes.bool,
		hover: PropTypes.bool,
		active: PropTypes.bool,
		type: PropTypes.oneOf(['caption']),
		className: PropTypes.string,
		location: PropTypes.oneOf(['end', 'middle']),
		style: PropTypes.object,
		truncatedTextExtraOptions: PropTypes.object,
		textDir: PropTypes.oneOf(['', 'ltr', 'rtl', 'auto']),
		numShape: PropTypes.bool,
	};

	static defaultProps = {
		className: '',
		style: {},
		truncatedTextExtraOptions: {},
		textDir: '',
	};

	render() {
		const {
			textDir,
			numShape,
			label,
			ellipsis,
			disabled,
			hover,
			active,
			type,
			htmlFor,
			className,
			style,
			location,
			truncatedTextExtraOptions,
			...others
		} = this.props;

		const classNames = cx(labelClassName, {
			disabled,
			active,
			hover,
			[type]: type,
		});

		const inner = ellipsis ? (
			<TruncatedText
				data-tid="ba-common-label__truncated-text"
				{...sanitize(truncatedTextExtraOptions, Label)}
				value={label}
				location={location}
				textDir={textDir}
				numShape={numShape}
			/>
		) : (
			Bidi.reshape(label, numShape)
		);

		if (htmlFor) {
			return (
				<label
					dir={resolveBaseTextDir(label, textDir, false)}
					{...sanitize(others, Label)}
					className={`${classNames} ${className}`}
					htmlFor={htmlFor}
					style={style}
				>
					{inner}
				</label>
			);
		}

		return (
			<span
				dir={resolveBaseTextDir(label, textDir, false)}
				{...sanitize(others, Label)}
				className={`${classNames} ${className}`}
				style={style}
			>
				{inner}
			</span>
		);
	}
}
